import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CLA_SETTINGS_FLAG, TabProps } from '../types';

import { extraHourSchema, fixedExtraHourNumberFields } from '../utils';

import Grid from '@mui/material/Grid';

import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { ControlledCheckbox } from '../../../../shared';
import ControlledSelect from '../../../../shared/ControlledFields/ControlledSelect';
import { useGetDhtOptions } from '../hooks/useGetCLASettings';

const ControlledNumericFieldWithReadMode = withReadModeField(
  ControlledNumericField
);
const ControlledSelectWithReadMode = withReadModeField(ControlledSelect);

const ExtraHoursTab = ({ setCurrentSchema, isEditable }: TabProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla'
  });

  const { data: dccDropdown } = useGetDhtOptions();

  useEffect(() => {
    setCurrentSchema(extraHourSchema);
  }, []);

  const { control } = useFormContext();

  return (
    <>
      <MultiStepForm.Section title={t('extraHours')}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {fixedExtraHourNumberFields.map((item, id) => (
            <Grid key={id} item xs={2} sm={4} md={4}>
              <ControlledNumericFieldWithReadMode
                key={`holidayHours_${id}`}
                variant="outlined"
                label={t(item.label)}
                name={item.name}
              />
            </Grid>
          ))}
          <Grid item xs={2} sm={4} md={4}>
            <ControlledCheckbox
              control={control}
              disabled={!isEditable}
              name={`flags[${CLA_SETTINGS_FLAG.EXTRA_HOURS_NOT_ROUNDED}]`}
              label={t('extraHoursNotRounded')}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <ControlledNumericFieldWithReadMode
              variant="outlined"
              label={t('maxPayedHoursPerPeriod')}
              name={'extraMaxPeriodPaid'}
            />
          </Grid>
        </Grid>
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('extraHoursProcedureDutyType')}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={2} sm={4} md={4}>
            <ControlledCheckbox
              disabled={!isEditable}
              control={control}
              name={`flags[${CLA_SETTINGS_FLAG.PROC_EXTRA_HOURS_NOMINAL}]`}
              label={t('extraHoursProcedure')}
            />
          </Grid>
          <Grid item xs={2} sm={4} md={4}>
            <ControlledSelectWithReadMode
              control={control}
              variant="outlined"
              name={'procExtraNomDutyTypeId'}
              label={t('extraHoursProcedureDutyType')}
              options={dccDropdown ?? []}
            />
          </Grid>
        </Grid>
      </MultiStepForm.Section>
    </>
  );
};

export default ExtraHoursTab;
